import './page/acris-blogs-index';
import './acris-settings-item.scss';

const { Module } = Shopware;

Module.register('acris-blogs', {
    type: 'plugin',
    name: 'AcrisBlog',
    title: 'acris-blogs.general.mainMenuItemGeneral',
    description: 'acris-blogs.general.descriptionTextModule',
    version: '1.0.0',
    targetVersion: '1.0.0',
    color: '#a6c836',
    icon: 'regular-image-text',

    routes: {
        index: {
            component: 'acris-blogs-index',
            path: 'index',
            icon: 'regular-image-text',
            meta: {
                parentPath: 'sw.settings.index.plugins'
            }
        }
    },

    // navigation: [{
    //     id: 'acris-blogs-index',
    //     label: 'acris-blogs-index.general.mainMenuItemGeneral',
    //     color: '#a6c836',
    //     icon: 'regular-image-text',
    //     path: 'acris.faq.list.index',
    //     position: 1000,
    //     parent: 'sw-catalogue'
    // }],

    settingsItem: [
        {
            name: 'acris-blogs',
            to: 'acris.blogs.index',
            label: 'acris-blogs.general.mainMenuItemGeneral',
            group: 'plugins',
            icon: 'regular-image-text'
        }
    ]
});
